export const getInitialState = () => ({
  title: "",
  pivot: {
    certified: null,
    comments: "",
  },
});
